import { merge } from 'lodash';
import { APP_SETTINGS_VERSION_4 } from '@wix/wix-vod-constants/app-settings';

/* Don't change settings here! To change settings behavior, create new version */

export function migrateToV4(appSettingsV3) {
  const {
    colors = {}
  } = appSettingsV3;
  const {
    buttonsAndLinksColor,
    mainButtonColor
  } = colors;
  return merge({}, appSettingsV3, {
    numbers: {
      settingsVersion: APP_SETTINGS_VERSION_4
    },
    colors: {
      mainButtonColor: mainButtonColor || buttonsAndLinksColor
    }
  });
}
//# sourceMappingURL=version-4.js.map